/* global Swiper, attachEvent */

const playVideo = (videoElem, parentElem) => {
  videoElem.play();
  // eslint-disable-next-line no-param-reassign
  videoElem.controls = true;
  parentElem.classList.add('is-playing');
};

const pauseVideo = (videoElem) => {
  videoElem.pause();
};

// Play video
attachEvent('.video-slider__video-button', 'click', (ev) => {
  const parentElem = ev.target.closest('.video-slider__video');
  const videoElem = parentElem.querySelector('.video-slider__video-init');

  playVideo(videoElem, parentElem);
  ev.preventDefault();
});

// Video slider
const videoSliderElements = document.querySelectorAll('[data-slider="video-slider"]');

const videoSliderOptions = {
  slidesPerView: 1,
  watchOverflow: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

videoSliderElements.forEach((el) => {
  const videoSliderParent = el.closest('.video-slider');
  const arrowRight = videoSliderParent.querySelector('.arrow-right');
  const arrowLeft = videoSliderParent.querySelector('.arrow-left');

  videoSliderOptions.navigation.nextEl = arrowRight;
  videoSliderOptions.navigation.prevEl = arrowLeft;

  const videoSlider = new Swiper(el, videoSliderOptions);

  videoSlider.on('slideChange', () => {
    document.querySelectorAll('.video-slider__video.is-playing').forEach((elm) => {
      const videoElem = elm.querySelector('.video-slider__video-init');
      pauseVideo(videoElem);
    });
  });
});
